/*
* 随机数类
* 用途：生成各种随机数据
* 用法：vue.$random
* 方法：
*     randomString
*     randomTime
* */
class random {
  randomString (min, max) { // 生成长度为  min - max  的随机字符串  如果只给了  min  则生成长度为min的字符串
    var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var range = typeof max === 'undefined' ? min : Math.round(Math.random() * (max-min)) + min;
    var str = "";
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length-1));
      str += arr[pos];
    }
    return str;
  }
  randomNumber (min, max) { // 生成长度为  min - max  的随机数字  如果只给了  min  则生成长度为min的数字
    var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var range = typeof max === 'undefined' ? min : Math.round(Math.random() * (max-min)) + min;
    var str = "";
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length-1));
      str += arr[pos];
    }
    return str;
  }
  randomTime () { // 生成当前时间的组合，用于组合随机文件名，防止重复
    var date = new Date();
    return '' + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds();
  }
}

export default new random();



// WEBPACK FOOTER //
// ./src/utils/random.js